import type { Npc, RoomDef } from '../defs.ts'
import { look } from '../town/kit.ts'

/** Sakura Tea: tatami, low tables and cushions, paper screens onto the garden. */
export const room: RoomDef = {
  id: 'teahouse',
  name: 'Sakura Tea',
  blurb: 'Tatami, cushions, and tea that takes its time.',
  w: 9, d: 8, outdoor: false, ground: 'tatami', accent: '#ff9cc2',
  wall: { color: '#f3e6d0', trim: '#6b4a34' },
  zones: [],
  spawn: [4, 4],
  props: [
    { kind: 'lowtable', x: 3, y: 2 }, { kind: 'cushion', x: 2, y: 2, face: 1, color: '#d94a5a' }, { kind: 'cushion', x: 4, y: 2, face: -1, color: '#d94a5a' },
    { kind: 'lowtable', x: 6, y: 5 }, { kind: 'cushion', x: 5, y: 5, face: 1, color: '#4a6fa5' }, { kind: 'cushion', x: 7, y: 5, face: -1, color: '#4a6fa5' },
    { kind: 'lowtable', x: 3, y: 6 }, { kind: 'cushion', x: 2, y: 6, face: 1, color: '#6a994e' }, { kind: 'cushion', x: 4, y: 6, face: -1, color: '#6a994e' },
    { kind: 'screen', x: 6, y: 0, color: '#f6efe0' },
    { kind: 'plant', x: 8, y: 7 }, { kind: 'lamp', x: 8, y: 1 },
  ],
  walls: [
    { kind: 'shoji', wall: 'back', at: 0.6, len: 2.4 },
    { kind: 'shoji', wall: 'back', at: 3.4, len: 2.4 },
    { kind: 'scroll', wall: 'left', at: 1.4, len: 1, text: '茶' },
    { kind: 'door', wall: 'left', at: 4, len: 1 },
    { kind: 'shoji', wall: 'left', at: 5.6, len: 2 },
  ],
  portals: [{ x: 0, y: 4, to: 'town', out: [1, 4], label: 'Outside' }],
  critters: [],
  places: [], spots: [], cap: 24, softCap: 18,
}

export const npcs: Npc[] = [
  {
    id: 'npc-sen', name: 'Master Sen', role: 'Tea master', look: look('mastersen', 0, 4, 1, 'none'), speed: 0.8,
    stops: [
      { x: 5, y: 2, wait: 20, emote: 'thinking', say: -1 },
      { x: 2, y: 4, wait: 12, say: -1 },
      { x: 7, y: 3, wait: 15, emote: 'happy' },
    ],
    lines: ['Sit. The tea will find you.', 'Sencha today. Gentle, like the hill.', 'Leave your shoes, keep your hat.', 'The best cup is the one you share.'],
  },
]
